<template lang="html">
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title class="grey lighten-4">
          <v-tooltip top>
                  <v-btn
                        slot="activator"
                        dark
                        @click.stop="dialog = true"
                        icon class="mx-0">
                     <v-icon color="red">help</v-icon>
                 </v-btn>
             <span>Agremiados/Usuarios</span>
          </v-tooltip>
          <h3 class="headline mb-0">Administración de Agremiados</h3>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="nuevoUsuario">Agregar</v-btn>
        </v-card-title>
          <v-card-title primary-title class="grey lighten-4">
            <v-spacer></v-spacer>
            <v-text-field
              :loading="loading"
              v-model="search"
              label="Buscar"
              single-line
              hide-details
              :append-outer-icon="loading ? 'update' : 'search'"
              @change="searchFilterUser"
            ></v-text-field>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="users"
                rows-per-page-text="Filas por Página"
                :pagination.sync="pagination"
                :total-items="total"
                :rows-per-page-items="rowsPerPageItems"
                row
                wrap
                class="elevation-1"
             >
               <template slot="items" slot-scope="props">

                 <td>
                    <v-avatar size="36px">
                        <img v-if="props.item.foto" :src="props.item.foto">
                        <v-icon v-else color="primary">person</v-icon>
                    </v-avatar>
                 </td>
                 <td>
                   <v-icon v-if="props.item.firma" color="success">done_all</v-icon>
                   <v-icon v-else color="error">close</v-icon>
                 </td>
                 <td>{{ props.item.unionize == null || props.item.unionize.cpc == null ? 'N/A' : props.item.unionize.cpc }}</td>
                 <td>{{ props.item.number_id }} </td>
                 <td>{{ props.item.name }}</td>
                  <td>{{ props.item.diferencia == 0 || props.item.diferencia == null ? 0 : new Intl.NumberFormat("de-DE").format(props.item.diferencia * -1) }}</td>
                 <!-- <td>{{ props.item.email }}</td> -->
                 <td class="justify-center layout px-0">

                    <v-tooltip top>
                        <v-btn :disabled="props.item.unionize != null" slot="activator" icon class="mx-0" @click="juramentarAgremiado(props.item)">
                          <v-icon color="cyan">pan_tool</v-icon>
                        </v-btn>
                        <span>Juramentar</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <v-btn :loading="this.uploadPhoto" :disabled="props.item.unionize == null || props.item.unionize.cpc == null" slot="activator" icon class="mx-0" @click="uploadPhotoAgremiado(props.item.unionize.cpc)">
                          <v-icon color="black">camera_alt</v-icon>
                        </v-btn>
                        <span>Cambiar Foto</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <v-btn :loading="this.uploadFirma" :disabled="props.item.unionize == null || props.item.unionize.cpc == null" slot="activator" icon class="mx-0" @click="uploadFirmaAgremiado(props.item.unionize.cpc)">
                          <v-icon color="black">gesture</v-icon>
                        </v-btn>
                        <span>Cambiar Firma</span>
                    </v-tooltip>

                   <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" :disabled="props.item.foto != null && props.item.firma != null && props.item.unionize != null ? false : true" @click.native="downloadCarnetPdf(props.item.unionize.cpc)">
                          <v-icon color="primary">contacts</v-icon>
                        </v-btn>
                        <span>Generar Carnet</span>
                    </v-tooltip>

                   <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" @click="verUsuario(props)">
                          <v-icon color="blue darken-2">description</v-icon>
                        </v-btn>
                        <span>Ficha</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" @click="editarUsuario(props)">
                          <v-icon color="info">edit</v-icon>
                        </v-btn>
                        <span>Editar Usuario</span>
                    </v-tooltip>
                    
                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" @click="changePasswordUser(props)">
                          <v-icon color="primary">enhanced_encryption</v-icon>
                        </v-btn>
                        <span>Cambiar Password</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" @click="generarDeuda(props)">
                          <v-icon color="warning">monetization_on</v-icon>
                        </v-btn>
                        <span>Generar Deuda</span>
                    </v-tooltip>

                    <!-- <v-tooltip top>
                        <v-btn :loading="this.addEventUser" slot="activator" icon class="mx-0" @click="addUserEvent(props)">
                          <v-icon color="primary">library_add</v-icon>
                        </v-btn>
                        <span>Agregar a Evento</span>
                    </v-tooltip> -->
                    
<!-- 
                    <v-tooltip top>
                        <v-btn slot="activator" icon class="mx-0" @click="changeRoleUser(props)">
                          <v-icon color="primary">group_add</v-icon>
                        </v-btn>
                        <span>Agregar Rol</span>
                    </v-tooltip> -->
                </td>
               </template>
               <v-alert slot="no-results" :value="true" color="error" icon="warning">
                 La busqueda para  "{{ search }}" No resultó.
               </v-alert>
             </v-data-table>

          </v-card-text>
      </v-card>
    </v-flex>

    <!-- dialog para form event -->
    <v-dialog
      v-model="dialogFormUser"
      width="600"
      persistent
    >
      <formUsers :universities="universities" :colleges="colleges" :tipo="tipo" :datos="getUserDatos" v-on:closeDialogUser="closeDialogUser($event)"></formUsers>
    </v-dialog>
    <!-- fin dialog form event -->

    <!-- dialog para form event -->
    <v-dialog
      v-model="dialogUserEvent"
      width="600"
      persistent
    >
      <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #9C1A1A">Agregar a Evento</span></h3>
          </v-card-title>
          <v-card-text>
            <v-select
              v-if="this.events.length != 0"
              :items="events"
              v-model="formEventUser.evento_id"
              item-text="subject"
              item-value="id"
              label="Evento"
              :rules="[v => !!v || 'El evento es requerido']"
              required
            ></v-select>
            <p v-else>No existen eventos activos!</p>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="cerrarDialogEventUser()">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="this.events.length != 0" :loading="loading" class="primary" @click="submitForm">Agregar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- fin dialog form event -->
    <input hidden type="file" ref="fileInput" @change="processFile($event)">

    <UploadFile :showUpload="uploadPhoto"  :cpc="uploadcpc" v-on:upload="uploadPhoto = $event" v-on:userdata="setUsersData" />

    <!-- Inicio de dialogo -->
    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">Agremiados y/o Usuarios</v-card-title>

        <v-card-text>
          Gestión de usuarios y agremiados del Colegio de Contadores con la emisión de carnet.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialog = false"
          >
            Salir
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->

    <!-- dialog para form role user -->
    <v-dialog v-model="dialogRoleUser" width="600" persistent>
      <formRoleUser :loading="loading" v-if="dialogRoleUser" :id="id" v-on:closeDialogUserRole="closeDialogUserRole($event)" v-on:loadingResponse="loading = $event" />
    </v-dialog>
    <!-- fin dialog form role user -->

    <!-- dialog para form juramentar -->
    <v-dialog v-model="dialogJuramentar" width="600" persistent>
      <formJuramentacion :colleges="colleges" :loading="loading" :item="itemDataAgremiado" v-on:closeDialogJuramentacion="closeDialogJuramentacion($event)" v-on:loadingResponse="loading = $event" />
    </v-dialog>
    <!-- fin dialog form juramentar -->

    <!-- dialog para form cambiar password -->
    <v-dialog v-model="dialogPasswordUser" width="600" persistent>
      <formChanguePassword :agremiado="formEventUser" :loading="loading" v-on:loadingResponse="loading = $event" v-on:closeDialogChanguePassworUser="closeDialogChanguePassworUser($event)" />
    </v-dialog>

    <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
    >
        <v-card
            color="primary"
            dark
        >
            <v-card-text>
            Porfavor Espere...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import formUsers from '~/pages/admin/formUsers.vue'
import formRoleUser from '~/pages/admin/formRoleUser.vue'
import formJuramentacion from '~/pages/admin/formJuramentacion.vue'
import formChanguePassword from '~/pages/admin/formChanguePassword.vue'
import UploadFile from '~/components/carnet/upload_file.vue'

export default {
  name: 'adminuser-view',

  components: {
    formUsers,
    formRoleUser,
    formJuramentacion,
    formChanguePassword,
    UploadFile
  },

  computed: {
    ...mapGetters({
      authenticated: 'authCheck'
    }),
    getUserDatos () {
      return this.editItem
    }
  },

  watch: {
    pagination() {
      this.getUserByPagination();
    }
  },

  mounted() {
    this.getUniversities()
  },

  data () {
    return {
      id: null,
      universities: [],
      valid: false,
      dialog: false,
      dialogUserEvent: false,
      dialogRoleUser: false,
      dialogJuramentar: false,
      dialogPasswordUser: false,
      events: [],
      colleges: [],
      users: [],
      addEventUser: false,
      uploadPhoto: false,
      uploadFirma: false,
      uploadcpc: '',
      activePagination: false,
      total: 0,
      formEventUser: {
        user_id: null,
        evento_id: '',
        sector: 'PARTICULAR'
      },
      pagination: {},
      loading: false,
      dialogFormUser: false,
      dialogGrafico: false,
      tipo: '',
      search: '',
      editItem: {},
      itemDataAgremiado: {},
      headers: [
        { text: 'FOTO', sortable: false },
        { text: 'FIRMA', sortable: false },
        { text: 'CPC', value: 'cpc', sortable: false },
        { text: 'CEDULA', value: 'number_id', sortable: false },
        { text: 'USUARIO', value: 'name', sortable: false },
        { text: 'SALDO BsS', value: 'diferencia', sortable: false },
        // { text: 'E-MAIL', value: 'email', sortable: false },
        { text: 'Acciones', value: 'acciones', sortable: false }
      ],
      rowsPerPageItems: [10, 20, 50, 100],
      firma: {
        cpc: '',
        tipo: 'firma',
        img: null,
        file: null
      }
    }
  },

  methods: {

    changePasswordUser(props) {
      this.formEventUser.user_id = props.item.id
      this.formEventUser.email = props.item.email
      this.dialogPasswordUser = true
    },

    closeDialogChanguePassworUser () {
      this.dialogPasswordUser = false
      this.formEventUser = {
        user_id: null,
        evento_id: '',
        sector: 'PARTICULAR'
      }
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
    },

    async generarDeuda(agremiado) {
      this.loading = true
        await axios.post('/api/unionazes/administration/generar-deuda', { unionize_id: agremiado.item.unionize.id})
          .then(resp => {
            console.log(resp.data)
            this.getUserByPagination()
          })
          .catch(e => {
            console.log(e.response.data)
            if (e.response.data.errors) {
              if (e.response.data.errors.msg) {
                this.$store.dispatch('responseMessage', {
                  type: 'warning',
                  text: e.response.data.errors.msg
                })
              }
            }
            console.log(e.response.data)
            this.loading = false
          })
    },

    async getUserByPagination () {
      this.loading = true;
      if (this.search) {
          await axios.get(`/api/users/administration/users-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
              .then(res => {
                  console.log(res, 'data')
                  this.users = res.data.data;
                  this.total = res.data.total;
              })
              .catch(e => {
                console.log(e.response)
              })
              .finally(() => this.loading = false);
      }
      if (this.pagination.sortBy && !this.search) {
          const direction = this.pagination.descending ? 'desc' : 'asc';
          await axios.get(`/api/users/administration/users-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
              .then(res => {
                  // console.log(res, 'data')
                  this.loading = false;
                  this.users = res.data.data;
                  this.total = res.data.total;
              })
              .finally(() => this.loading = false);
      }
      if(!this.search && !this.pagination.sortBy) {
          await axios.get(`/api/users/administration/users?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
              .then(res => {
                  console.log(res, 'data')
                  this.users = res.data.data;
                  this.total = res.data.total;
              })
              .finally(() => this.loading = false);
      }
    },

    async getUniversities () {
      this.loading = true
      await axios.get('/api/universities/getAllUniversities')
        .then(resp => {
          this.universities = resp.data.universities
          this.colleges = resp.data.colleges
          this.events = resp.data.events
        })
        .catch(e => {
          console.log(e.response,"error");
        })

      this.loading = false
    },

    uploadPhotoAgremiado(cpc) {
      this.uploadcpc = cpc
      this.uploadPhoto = true
    },

    uploadFirmaAgremiado(cpc) {
      this.uploadcpc = cpc
      this.onFocus()
    },

    onFocus() {
      this.$refs.fileInput.value = ''
      this.$refs.fileInput.click()
    },

    processFile(event) {
      let files = event.target.files || event.dataTransfer.files
      if (files[0].type == "image/png" || files[0].type == "image/jpg" || files[0].type == "image/jpeg") {
        //loading
        this.loading = true
        this.uploadFirma = true
        this.firma.img = files[0]
        this.firma.cpc = this.uploadcpc

        let formData = new FormData()
        for (var key in this.firma) {
          formData.append(key, this.firma[key])
        }

        axios.post('/api/agremiado/fotoCarnet', formData)
          .then(resp => {
            let item = this.users.find(users => users.id === resp.data.id)
            Object.assign(item, resp.data)
            this.loading = false
            this.uploadFirma = true
          })
          .catch(e => {
            console.log(e.response)
            this.loading = false
            this.uploadFirma = true
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: 'No se logro guardar el archivo, Intente nuevamente'
            })
          })

      }else {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          text: 'El formato de la firma debe ser PNG/JPG/JPEG'
        })
      }
    },

    searchFilterUser () {
      this.getUserByPagination()
    },

    juramentarAgremiado (item) {
      this.itemDataAgremiado = item
      this.dialogJuramentar = true
    },

    nuevoUsuario () {
      this.tipo = "crear"
      this.editItem = {}
      this.dialogFormUser = true
    },

    verUsuario (props) {
      this.tipo = "ver"
      this.editItem = props.item
      this.dialogFormUser = true
    },

    editarUsuario (props) {
      this.tipo = "editar"
      this.editItem = props.item
      this.dialogFormUser = true
    },

    setUsersData (props) {
      let item = this.users.find(users => users.id === props.id)
      Object.assign(item, props)
    },

    downloadCarnetPdf(cpc) {
      window.location.assign('api/agremiado/downloadCarnet/' + cpc);
    },

    addUserEvent(props) {
      this.formEventUser.user_id = props.item.id
      this.formEventUser.email = props.item.email
      this.dialogUserEvent = true
    },

    changePasswordUser(props) {
      this.formEventUser.user_id = props.item.id
      this.formEventUser.email = props.item.email
      this.dialogPasswordUser = true
    },

    changeRoleUser(props) {
      this.id = props.item.id
      this.dialogRoleUser = true
    },

    async submitForm() {
      this.loading = true
      this.addEventUser = true
      await axios.post('/api/cursos/registerUserEvent',this.formEventUser)
        .then(resp => {
          this.$store.dispatch('responseMessage', {
              type: 'success',
              text: 'Has agregado el agremiado al evento!'
          })
          this.cerrarDialogEventUser()
        })
        .catch(e => {
          this.loading = false
          this.addEventUser = false
          if (e.response.data.errors.cupos_llenos) {
            this.$store.dispatch('responseMessage', {
              type: 'warning',
              text: e.response.data.errors.cupos_llenos
            })
          }else if (e.response.data.errors.estas_registrado) {
            this.$store.dispatch('responseMessage', {
              type: 'warning',
              text: e.response.data.errors.estas_registrado
            })
          }else {
            this.$store.dispatch('responseMessage', {
              type: 'warning',
              text: e.response.data.errors
            })
          }
        })

      this.loading = false
    },

    closeDialogUserRole () {
      this.dialogRoleUser = false
      setTimeout(function(){
        this.id = null
      }, 3000)
    },

    closeDialogUser (response) {
      if (response != null) {
        var item = this.users.find(user => user.id === response.id)
        if (this.tipo == 'crear') {
          this.users.push(response)
        }else {
          Object.assign(item, response)
        }
        this.search = response.email
        this.getUserByPagination()
      }
      this.dialogFormUser = false
      setTimeout(function(){
        this.editItem = {}
        this.tipo = ''
      }, 3000)
    },

    closeDialogJuramentacion (response) {
      if (response != null) {
        var item = this.users.find(user => user.id === response.id)
        Object.assign(item, response)
        this.search = response.email
        this.getUserByPagination()
      }
      this.dialogJuramentar = false
      setTimeout(function(){
        this.itemDataAgremiado = {}
      }, 3000)
    },

    cerrarDialogEventUser () {
      this.dialogUserEvent = false
      this.addEventUser = false
      this.formEventUser = {
        user_id: null,
        evento_id: '',
        sector: 'PARTICULAR'
      }
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
    }, 

    closeDialogChanguePassworUser () {
      this.dialogPasswordUser = false
      this.formEventUser = {
        user_id: null,
        evento_id: '',
        sector: 'PARTICULAR'
      }
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
    },

  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/adminuser.vue